export default "__VITE_ASSET__53bfdfa7__"